import { render } from "./plots.vue?vue&type=template&id=36ea9d52"
import script from "./plots.vue?vue&type=script&lang=js"
export * from "./plots.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__